import { create } from "zustand";

/**
 * Ponte entre o chat e o projeto aberto: referências como `src/app.js:12` nas mensagens viram
 * links que abrem o arquivo na linha (só quando há um projeto aberto com esse arquivo).
 */
export const codeLinks: {
  current: { exists(path: string): boolean; open(path: string, line: number): void } | null;
} = { current: null };

/** `caminho:linha` ou `caminho:inicio-fim` dentro de um código inline. */
export function parseCodeRef(text: string): { path: string; line: number; end?: number } | null {
  const m = /^([\w@.\-/]+\.[A-Za-z0-9]+)(?::(\d+)(?:-(\d+))?)?$/.exec(text.trim());
  if (!m) return null;
  return { path: m[1]!, line: m[2] ? Number(m[2]) : 1, ...(m[3] ? { end: Number(m[3]) } : {}) };
}

/** Rascunho para o campo do chat (ex.: trecho de código enviado do editor). */
export const useChatDraft = create<{ key: string | null; text: string; at: number }>(() => ({
  key: null,
  text: "",
  at: 0,
}));

export function draftToChat(key: string, text: string) {
  useChatDraft.setState({ key, text, at: Date.now() });
}

/** Mensagem com a referência e o trecho (cercado como código), dentro do limite do chat. */
export function snippetMessage(
  path: string,
  from: number,
  to: number,
  code: string,
  lang: string,
  max = 3500,
) {
  const ref = from === to ? `${path}:${from}` : `${path}:${from}-${to}`;
  let body = code.replace(/\s+$/, "");
  const lines = body.split("\n");
  if (lines.length > 60) body = `${lines.slice(0, 60).join("\n")}\n…`;
  if (body.length > max) body = `${body.slice(0, max)}\n…`;
  return `\`${ref}\`\n\`\`\`${lang}\n${body}\n\`\`\`\n`;
}
